export default function initContentVideo() {
    // ==========================================================
    // CONTENT VIDEO
    // ==========================================================
    const videos = document.querySelectorAll("[data-video]");

    videos.forEach((video) => {
        const playButton = video.querySelector("[data-video-play]");

        if (!playButton) {
            return;
        }

        playButton.addEventListener("click", () => {
            const videoUrl = video.dataset.videoUrl;

            if (!videoUrl) {
                return;
            }

            const iframe = document.createElement("iframe");

            iframe.src = `${videoUrl}?autoplay=1&rel=0`;
            iframe.className = "absolute inset-0 h-full w-full";

            iframe.title = "YouTube video player";

            iframe.allow = "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share";

            iframe.allowFullscreen = true;

            video.innerHTML = "";
            video.appendChild(iframe);
        });
    });
}
